"use client";
import React, { useMemo, FC } from "react";

import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";

import { getTestAutomationProps } from "~/helpers/test-automation-props";
import { Nullable } from "~/types/general.types";

import { PROGRESS_BAR_CLASSES, DEFAULT_PROGRESS_BAR_TEXT } from "./constants";
import { ProgressBarContainer } from "./styled";

export interface ProgressBarProps {
  progressBarText?: Nullable<string>;
  className?: string;
  current: number;
  total?: Nullable<number>;
}

export const ProgressBar: FC<ProgressBarProps> = ({
  progressBarText,
  className,
  current,
  total,
}) => {
  const normalizedTotal = total ?? 1;

  const normalizedCurrentProgress = useMemo(
    () => Math.min(1, current / normalizedTotal),
    [current, normalizedTotal],
  );
  const processedCaption = useMemo(() => {
    return (progressBarText ?? DEFAULT_PROGRESS_BAR_TEXT)
      .replace("{{number}}", current?.toString())
      .replace("{{number}}", normalizedTotal?.toString());
  }, [progressBarText, current, normalizedTotal]);

  const testAutomationId = "progress-bar";

  return (
    <ProgressBarContainer
      id={testAutomationId}
      normalizedCurrentProgress={normalizedCurrentProgress}
      className={className}
      {...getTestAutomationProps(testAutomationId)}
    >
      <Box className={PROGRESS_BAR_CLASSES.bar}>
        <Box className={PROGRESS_BAR_CLASSES.indicator} />
      </Box>
      <Typography className={PROGRESS_BAR_CLASSES.centered} variant="body2">
        {processedCaption}
      </Typography>
    </ProgressBarContainer>
  );
};
